import { useGoogleAnalyticsContext } from "contexts/GoogleAnalyticsProvider";
import { useWebStoreContext } from "contexts/WebStoreProvider";
import { ProfileIcon } from "utils/svgIcons";
import { UserProfileImage } from "../styled";

export const ProfileImage = () => {
	const { profileImage } = useWebStoreContext();
	const { reportEvent, reportPlaygamiEvent } = useGoogleAnalyticsContext();
	return (
		<UserProfileImage>
			{profileImage ? (
				<img
					src={profileImage}
					onClick={() => {
						reportEvent("profile_click", { source: "navbar" });
						reportPlaygamiEvent("tp.web_frontend", {
							event_name: "profile_click",
							event_type: "top navbar",
							action: "profile_click",
							source: "navbar"
						});
					}}
				/>
			) : (
				<ProfileIcon />
			)}
		</UserProfileImage>
	);
};
